import { api } from "../utils/axios";

/**
 * Fetch usage frequency report
 * @param {Object} params - { startDate, endDate, interval }
 */
export const fetchUsageFrequency = async (params = {}) => {
    try {
        const response = await api.get("/reports/usage-frequency", { params });
        return response.data.data;
    } catch (error) {
        console.error("Error fetching usage frequency:", error);
        throw error;
    }
};


/**
 * Fetch detailed report by type
 * @param {string} reportType 
 * @param {Object} params - { startDate, endDate, hostRef, domeRef, interval }
 */
export const fetchDetailedReport = async (reportType, params = {}) => {
    try {
        const response = await api.get(`/reports/detail`, { params: { ...params, reportName: reportType } });
        return response.data.data;
    } catch (error) {
        console.error(`Error fetching ${reportType} report:`, error);
        throw error;
    }
};

// fetchHosts is NOT needed for Host App (they only see themselves)

/**
 * Fetch domes for a specific host (The logged in host)
 * @param {string} hostRef 
 */
export const fetchDomesByHost = async (hostRef) => {
    try {
        const response = await api.get("/dome/host", { params: { hostRef, limit: 1000 } });
        return response.data.data.domes;
    } catch (error) {
        console.error("Error fetching domes for host:", error);
        throw error;
    }
};
